import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { Globe, ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import VrestoEdoLogo from "../assets/VrestoEdo_Logo.png";
import { documentCategories } from "../data/documentCategories";

const Header = () => {
  const { language, setLanguage } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [isHome, setIsHome] = useState(location.pathname === "/");

  useEffect(() => {
    const path = location.pathname;
    setIsHome(path === "/");

    const pathParts = path.split("/").filter(Boolean);

    if (pathParts.length === 2 && pathParts[0] === "category") {
      const cat = documentCategories.find((c) => c.id === parseInt(pathParts[1]));
      if (cat) setDynamicTitle(language === "el" ? cat.title : cat.titleEn);
    } else if (pathParts.length === 2 && pathParts[0] === "subcategory") {
      let parent = null;
      let sub = null;
      for (const c of documentCategories) {
        const s = c.subcategories?.find((sc) => sc.id === pathParts[1]);
        if (s) {
          parent = c;
          sub = s;
          break;
        }
      }
      if (sub && parent)
        setDynamicTitle(
          language === "el"
            ? `${parent.title} / ${sub.name}`
            : `${parent.titleEn} / ${sub.nameEn}`
        );
    } else {
      setDynamicTitle("");
    }
  }, [location, language]);

  const handleBack = () => navigate(-1);

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate("/");
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 300);
  };

  // ✅ NEW: SAVE USER CHOICE
  const toggleLanguage = () => {
    const newLang = language === "el" ? "en" : "el";
    setLanguage(newLang);
    localStorage.setItem("vresto_lang", newLang);
  };

  return (
    <header
      className="
        fixed top-0 left-0 w-full z-50
        backdrop-blur-lg bg-white/5 border-b border-white/10 text-white
        py-4 px-6 sm:px-10
        flex flex-col md:grid md:grid-cols-[1fr_auto_1fr] md:items-center
        gap-3 md:gap-6
        transition-all duration-500 ease-in-out
      "
    >
      {/* LEFT */}
      <div
        className="
          flex items-center justify-between md:justify-start gap-3 w-full md:w-auto
        "
      >
        <a href="/" onClick={handleLogoClick} className="group cursor-pointer">
          <div
            className="
              flex items-center justify-center rounded-2xl shadow-lg
              transform group-hover:scale-110
              w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16
            "
            style={{ backgroundColor: "#1D2951" }}
          >
            <img
              src={VrestoEdoLogo}
              alt="VrestoEdo.gr"
              className="object-contain h-full w-full"
            />
          </div>
        </a>

        <div className="flex items-center gap-3 md:hidden">
          {!isHome && (
            <button
              onClick={handleBack}
              className="flex items-center gap-1 text-sm text-blue-100 px-2 py-1 rounded-lg border border-white/20 bg-white/10"
            >
              <ArrowLeft size={14} />
            </button>
          )}

          <button
            onClick={toggleLanguage}
            className="flex items-center gap-1 text-sm hover:text-blue-300"
          >
            <Globe size={14} />
            {language === "el" ? "EN" : "ΕΛ"}
          </button>
        </div>
      </div>

      {/* CENTER */}
      <div className="flex flex-col items-center text-center w-full">
        <h1 className="text-2xl font-bold mb-1">
          {dynamicTitle
            ? dynamicTitle
            : language === "el"
            ? "Βρες Εύκολα Online Έγγραφα και Υπηρεσίες"
            : "Find Online Documents and Services Easily"}
        </h1>

        {!dynamicTitle && (
          <p className="text-blue-200 font-medium max-w-3xl leading-snug">
            {language === "el"
              ? "Γρήγορη πρόσβαση σε χρήσιμους συνδέσμους για φορολογικά, ασφαλιστικά, υγειονομικά και άλλα έγγραφα και υπηρεσίες."
              : "Quick access to useful links for tax, insurance, health, and other public services."}
          </p>
        )}
      </div>

      {/* RIGHT */}
      <div className="hidden md:flex items-center justify-end gap-4">
        {!isHome && (
          <button
            onClick={handleBack}
            className="flex items-center gap-1 text-sm text-blue-100 px-3 py-1.5 rounded-lg border border-white/20 bg-white/10"
          >
            <ArrowLeft size={16} />
            <span className="hidden sm:inline">
              {language === "el" ? "Πίσω" : "Back"}
            </span>
          </button>
        )}

        <button
          onClick={toggleLanguage}
          className="flex items-center gap-1 text-sm hover:text-blue-300"
        >
          <Globe size={16} />
          {language === "el" ? "EN" : "ΕΛ"}
        </button>
      </div>
    </header>
  );
};

export default Header;
